import { h } from 'preact';
import React, { Component } from 'react';

import Accordion from '../Components/Accordion';
import PurposeContent from './PurposeContent';
import { makeText } from '../../../util';

export default class Purposes extends Component {
  state = {
    forceUpdate: true
  }
  force = () => this.setState({ forceUpdate: !this.state.forceUpdate })
  render() {
    const {
      stacks,
      purposes,
      settings,
      language,
      dev,
    } = this.props;
    return (
      <div className="pm-purposes">

        {purposes.map(p => (
          <Accordion
            key={`purpose-${p._id}`}
            settings={settings}
            name={<span>{p.name}</span>}
            accessName={p.name}
            description={p.description}
            child="purposes"
            language={language}
            value={p}
            vendors={p.requiringConsentVendors}
            content={<PurposeContent purpose={p} language={language} settings={settings} force={this.force} dev={dev} />}
            toggle={this.props.toggleCategory}
            updateMe={this.state.forceUpdate}
            dev={dev}
          />
        ))}

      </div>
    );
  }
}
